import { TCountryValidation } from './validationByCountryCode';

// This is a protection against potential ReDOS attack
// Running regex for a lot of characters might cause the CPU usage to be too high and could crash server
// This number is not set in stone so if needed can be increased
const MAX_LICENSE_PLATE_LENGTH = 15;

export default (licensePlate: string, validation: TCountryValidation): boolean => {
  if (!validation || !licensePlate || licensePlate.length > MAX_LICENSE_PLATE_LENGTH) {
    return false;
  }

  return validation.pattern.test(licensePlate);
};
